import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import ProductCard from "@/components/Shared/UpsellInstallServices/ProductCardForUpsell/ProductCard"
import styles from "@/components/Shared/UpsellInstallServices/ProductCardForUpsell/index.module.scss"
import _isEmpty from "lodash/isEmpty"
import { getConfig } from "@/constants/config"
import {
  getProductDataFromSkuIds,
  getProductInventory,
} from "@/components/Shared/UpsellInstallServices/api"
import { getUserPersona } from "@/utils/helper"
import { getRowCols } from "@/utils/index"
import { isMobile, isTablet } from "react-device-detect"
import useWindowResize from "@/hooks/useWindowResize"
import { addToCartItem } from "@/utils/addTocart"
import { addToCart, setCart } from "@/store/features/cartSlice"
import { showPreviewCart } from "@/store/features/genericSlice"

const ProductCardForUpsell = ({ authData = {} }) => {
  const {
    skuIds = [],
    presetConfigs = "",
    swatchUrl = "",
    outOfStockTitle = "",
  } = authData
  const [width] = useWindowResize()
  const dispatch = useDispatch()
  const rowCols = getRowCols(width, isMobile, isTablet)
  const persona = getUserPersona()
  const [recommendedProductData, setRecommendedProductData] = useState([])
  const [currency, setCurrencySign] = useState("$")
  const [brand, setBrand] = useState("kohler")
  const callToFetchRecommendedProductData = () => {
    getConfig().then(config => {
      if (!_isEmpty(config)) {
        const {
          general: { lwAppName = "", siteName = "kohler" } = {},
          internationalization: { currencySign = "$" } = {},
        } = config
        if (skuIds.length)
          getRecommendedProductData({ lwAppName, currencySign, siteName })
      }
    })
  }

  useEffect(() => {
    if (persona) callToFetchRecommendedProductData()
  }, [persona])
  const getRecommendedProductData = ({
    lwAppName = "",
    currencySign = "$",
    siteName = "kohler",
  }) => {
    getProductDataFromSkuIds(persona, skuIds, lwAppName).then(async res => {
      const skuidString = skuIds.join(",")
      if (!_isEmpty(res) && skuidString) {
        const { data: { response: { docs = [] } = {} } = {} } = res

        const { data: { results: productInventory = [] } = {} } =
          (await getProductInventory(skuidString)) ?? {}

        const updatedDocs = []
        docs.forEach(item => {
          const matchItem = productInventory.find(
            product => product.sku === item.sku_s
          )
          if (matchItem) {
            updatedDocs.push({
              ...item,
              quantity: matchItem?.availableQuantity,
            })
          }
        })

        setCurrencySign(currencySign)
        setBrand(siteName)
        setRecommendedProductData(updatedDocs)
      }
    })
  }
  const handleAddToCart = async (items = [], cb = () => {}) => {
    const payload = await addToCartItem([...items])
    const body = {
      actions: payload,
    }

    dispatch(addToCart(body))
      .unwrap()
      .then(res => {
        dispatch(showPreviewCart())
        const { payload = {} } = res
        if (!_isEmpty(payload)) {
          dispatch(setCart(payload))
        }
        cb()
      })
      .catch(err => {
        cb()
      })
  }
  return (
    <div className={styles.curatedProduct}>
      <div className="curated-product-recommendation">
        {recommendedProductData.map(item => {
          return (
            <React.Fragment key={item.id}>
              <ProductCard
                addToCart={handleAddToCart}
                {...item}
                persona={persona}
                currencySign={currency}
                brand={brand}
                presetConfigs={presetConfigs}
                rowCols={rowCols}
                swatchUrl={swatchUrl}
                outOfStockTitle={outOfStockTitle}
              />
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default ProductCardForUpsell
